<template>
  <component :is="cmpList[tmpType]" :comData="comData" :isEdit="isEdit"></component>
</template>

<script>
import styleOne from './components/style-one'
import styleTwo from './components/style-two'
import styleThree from './components/style-three'
import styleFour from './components/style-four'
import styleFive from './components/style-five'
export default {
  components: [styleOne,styleTwo,styleThree,styleFour,styleFive],
  props: {
		comData: {
			type: Object,
			default() {
				return {}
			}
		},
		isEdit: {
			type: Boolean,
			default: false
		},
    tmpType: {
      type: Number,
      default: 0
    }
	},
  data() {
    return {
      cmpList: [styleOne,styleTwo,styleThree,styleFour,styleFive]
    }
  }
}
</script>

<style>

</style>